export default "__VITE_ASSET__DVjKTXuz__"